import { render, staticRenderFns } from "./classifyForm.vue?vue&type=template&id=43ab1fa6"
import script from "./classifyForm.vue?vue&type=script&lang=js"
export * from "./classifyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports